/** Bumped on every undo/redo so property panels can refresh controls. */
let historyUiRevision = 0;
const listeners = new Set();

export function getHistoryUiRevision() {
  return historyUiRevision;
}

export function notifyHistoryUiRefresh() {
  historyUiRevision += 1;
  const revision = historyUiRevision;
  listeners.forEach((listener) => {
    try {
      listener(revision);
    } catch (error) {
      console.warn('History UI listener error:', error);
    }
  });
  if (typeof window !== 'undefined') {
    window.dispatchEvent(
      new CustomEvent('gridHistoryUiRefresh', { detail: { revision } })
    );
  }
  return revision;
}

export function subscribeHistoryUiRevision(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
